import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { MemberFormData, RoleOption, TeamOption } from '../types/memberNew.types';

export const memberNewService = {
  async getRoles(): Promise<RoleOption[]> {
    const { data, error } = await supabase
      .from('roles')
      .select('code, name')
      .order('name');
    if (error) throw error;
    return data || [];
  },

  async getTeams(companyId?: string): Promise<TeamOption[]> {
    let query = supabase
      .from('teams')
      .select('id, name')
      .order('name');
    
    if (companyId) {
      query = query.eq('company_id', companyId);
    }
    
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  },

  async createMember(data: MemberFormData): Promise<void> {
    await enforceSettingsPermission('settings.members.invite');
    const { data: createdUser, error } = await supabase
      .from('user_profiles')
      .insert({
        full_name: data.fullName,
        email: data.email,
        phone: data.phone,
        is_active: data.status === 'active',
        avatar_path: data.avatarPath
      })
      .select()
      .single();
    if (error) throw error;

    if (createdUser && data.roleCodes && data.roleCodes.length > 0) {
      const roleInserts = data.roleCodes.map(code => ({
        user_id: createdUser.id,
        role_code: code
      }));
      const { error: rolesError } = await supabase.from('user_roles').insert(roleInserts);
      if (rolesError) throw rolesError;
    }

    if (data.teamId && createdUser) {
      const { error: teamError } = await supabase
        .from('team_members')
        .insert({
          user_id: createdUser.id,
          team_id: data.teamId,
          member_role: 'member'
        });
      if (teamError) throw teamError;
    }
  }
};
